import { Component } from "react";
import Radio from "backbone.radio";

import { MarionetteToReact } from "extensions/MarionetteToReact";

import { View as TabsView, Model as TabsModel } from "./index";

import "./reactTabs.scss";

export class Tabs extends Component {
    static autoCollapse() {
        // Need to wait for tabs to be rendered
        window.setTimeout(() => {
            Radio.channel("tabEvents").trigger("autocollapse");
        }, 0);
    }
    
    componentDidMount() {
        Tabs.autoCollapse();
    }
    
    shouldComponentUpdate() {
        // We will not re-render tabs when state changes as it should be handled by underlying Marionette View and this React view is stateless
        return false;
    }
    
    componentDidUpdate(prevProps, prevState) {
        Tabs.autoCollapse();
    }
    
    getTabsModel() {
        return new TabsModel({
            newTabButton: this.props.newTabButton,
            stickyNav: this.props.stickyNav,
            name: this.props.name,
            tabs: this.props.children
        });
    }
    
    handleTabsEvents = (...args) => {
        if (typeof this.props.eventHandler === "function") {
            this.props.eventHandler(...args);
        }
    };
    
    render() {
        const theme = `pz-tabs ${this.props.theme}`;
        const style = {
            width: "100%"
        };
        
        return <MarionetteToReact style={style} View={TabsView} eventHandler={this.handleTabsEvents} model={this.getTabsModel()} propagateShowEvent={false} childClassName={theme}/>;
    }
}
